import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_target_change_summery",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "target_change_summery",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_target_change_summery_button",
  "data-kt-drawer-close": "#kt_drawer_target_change_summery_close",
  "data-kt-drawer-width": "50vw"
}
const _hoisted_2 = {
  id: "kt_target_change_summery",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_target_change_summery_header\"><h2 class=\"fw-bolder text-light\">Training Target Info</h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_target_change_summery_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_target_change_summery_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_target_change_summery_body",
  "data-kt-scroll-dependencies": "#kt_target_change_summery_header, #kt_target_change_summery_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "mb-5 mb-xl-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder container m-0 text-primary border-bottom border-2 py-4 px-8" }, " Training Target Info ", -1)
const _hoisted_9 = { class: "card-body p-9" }
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Tranche", -1)
const _hoisted_12 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_13 = { class: "fw-bold fs-6 me-2" }
const _hoisted_14 = { class: "row mb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Association", -1)
const _hoisted_16 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_17 = { class: "fw-bold fs-6 me-2" }
const _hoisted_18 = { class: "row mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Target Year ID", -1)
const _hoisted_20 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_21 = { class: "fw-bold fs-6 me-2" }
const _hoisted_22 = { class: "row mb-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Target Year From", -1)
const _hoisted_24 = { class: "col-lg-8" }
const _hoisted_25 = { class: "fw-bold fs-6 me-2" }
const _hoisted_26 = { class: "row mb-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Target Year To", -1)
const _hoisted_28 = { class: "col-lg-8" }
const _hoisted_29 = { class: "fw-bold fs-6 me-2" }
const _hoisted_30 = { class: "row mb-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Trainee Number ", -1)
const _hoisted_32 = { class: "col-lg-8" }
const _hoisted_33 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_34 = {
  key: 0,
  class: "d-flex justify-content-start pt-5"
}
const _hoisted_35 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_36 = {
  key: 0,
  class: "card-body p-0"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder container m-0 text-primary border-bottom border-2 py-4 pl-0" }, " Training Target Change Summery ", -1)
const _hoisted_38 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_39 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "bg-secondary",
    style: {"border":"1px solid #1db78d"}
  }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Column Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Old Data"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "New Data")
  ])
], -1)
const _hoisted_41 = {
  key: 0,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formData?.tranche_info?.label), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formData?.entity_info?.entity_name) + " (" + _toDisplayString(_ctx.formData?.entity_info?.entity_short_name) + ") ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formData?.target_year_info?.name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.formData?.target_year_from), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formData?.target_year_to), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.formData?.target_trainee_number), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (_ctx.updateLog && _ctx.formData.update_status == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              (_ctx.showChange == true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-warning px-3 py-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewChange()))
                  }, " Hide Change "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-info px-3 py-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewChange()))
                  }, " View Change "))
            ]))
          : _createCommentVNode("", true),
        (_ctx.showChange == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              (_ctx.updateLog && _ctx.formData.update_status == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        type: "hidden",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.id) = $event)),
                        id: "target_id"
                      }, null, 512), [
                        [_vModelText, _ctx.formData.id]
                      ]),
                      _createElementVNode("table", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableColumn, (cell, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateLog, (log, idx) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                                  (idx == cell.key)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                                        _createElementVNode("th", null, _toDisplayString(cell.name), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData, (item, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                            (index == cell.key)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_42, [
                                                  (index == 'tranche_id')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(_toDisplayString(_ctx.formData.tranche_info.label), 1)
                                                      ], 64))
                                                    : (index == 'entity_info_id')
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                          _createTextVNode(_toDisplayString(_ctx.formData.entity_info.entity_short_name), 1)
                                                        ], 64))
                                                      : (index == 'target_year_id')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                            _createTextVNode(_toDisplayString(_ctx.formData.target_year_info.name), 1)
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                            _createTextVNode(_toDisplayString(item), 1)
                                                          ], 64))
                                                ]))
                                              : _createCommentVNode("", true),
                                            (index == cell.key)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_43, [
                                                  (index == 'tranche_id')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(_toDisplayString(_ctx.updateLog.tranche_info.label), 1)
                                                      ], 64))
                                                    : (index == 'entity_info_id')
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                          _createTextVNode(_toDisplayString(_ctx.updateLog.entity_info.entity_short_name), 1)
                                                        ], 64))
                                                      : (index == 'target_year_id')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                            _createTextVNode(_toDisplayString(_ctx.updateLog.target_year_info.name), 1)
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                            _createTextVNode(_toDisplayString(log), 1)
                                                          ], 64))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ], 64))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}